import { createSlice } from '@reduxjs/toolkit';



const hoaSlice = createSlice({
  name: 'hoa',
  initialState: {
    selectedPlan: {
      planType: '',
      range: '',
      price: '',
      my: ''
    }
  },
  reducers: {
    setSelectedPlan(state, action) {
      state.selectedPlan = action.payload;
    }
  },
});

export const { setSelectedPlan } = hoaSlice.actions;

export default hoaSlice.reducer;